module.exports = __webpack_public_path__ + "img/图2.31b74942.jpg";